function ProjectSummary() {
/// <summary>
    /// This object provides the menu handling for the VC.Widget.Project.Summary.vb.<br/>
    /// Depending on the clicked menu item it loads various visuals. 
    /// Author: AFU<br />
    /// Date: 2.8.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.1.0 - 2.8.2017                                                *<br />
    /// **********************************************************************<br />
    /// * -  basic functionality                                             *<br />
    /// **********************************************************************<br />
    /// </summary>
}

ProjectSummary.prototype = new vcTemplate();

ProjectSummary.prototype.init = function () {
    /// <summary>
    /// This function sets specific widths, heights and inits the specific event handlers.<br/>
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.toggleMenu(me.visual.find(".button-toggle-active"));
        me.visual.find("#divMenu .button-toggle").off("click").on("click", function() {me.toggleMenu($(this))}).button();
        me.visual.find("#divFrame").height(parseInt(me.height - me.visual.find("#divCaption").height() - me.visual.find("#divMenu").height(), 10) +10);
        return true;
    } catch (ex) { me.writeError('init', ex); return false }
}


ProjectSummary.prototype.toggleMenu = function (obj) {
    /// <summary>
    /// This function handles the opening of the clicked menu items<br/>
    /// </summary>
    var me = this;
    var h, w,i;
    var param;
    var random;
    try {
        if (me.error) {
            return false;
        }
       
        me.visual.find("#divMenu .button-toggle").removeClass("button-toggle-active");
        obj.addClass("button-toggle-active");

        h = parseInt(me.visual.find("#divFrame").height(), 10);
        w = parseInt(me.visual.find("#divFrame").width(), 10);

        //get a random vcgid
        random = parseInt(Math.random()*100000,10);
        //fill a new div with the random id into the frame 
        var detail = $("<div>").attr("id", "divFrameDetail" + random).height(h).width(w).html(me.vcC.getLoadingIcon());
        me.visual.find("#divFrame").html(detail);
        param = { "loggerid": me.blid };

        switch (obj.data("type")) {
            case "STATUS":
                w = 1102;
                me.vcVisual.addVisualBaseByName('divFrameDetail', "WIDGET_LOGGEROVERVIEW", random, window.getCurrentTimestamp(), h-10, w, JSON.stringify(param), "", me.deviceType);
                break;
            case "EVENT":
                w = 1100;
                me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_MENU_TOGGLE_EVENT", random, window.getCurrentTimestamp(), h, w, JSON.stringify({ "loggerid": me.blid, 'FixedContentHeight':true }), "", me.deviceType);
                break;
            case "CONTACT":
                w = 1096;
                me.vcVisual.addVisualBaseByName('divFrameDetail', "WIDGET_PROJECT_CONTACTS", random,  window.getCurrentTimestamp(), h, w,"", JSON.stringify(param), me.deviceType);
                break;
            case "UNIT":
                w = 1105;
                var bluid = obj.data("bluid") + "";
                var bluids;
                if (bluid.indexOf(",") > 0) {

                    bluids = bluid.split(",");
                } else {
                    bluids = [bluid];
                }
                var sTmp = "";
                for (i = 0; i < bluids.length; i++) {
                    sTmp += "<div id='divFrameDetail" + random + "_" + i + "' class='detailedUnits'></div>";

                }
                me.visual.find("#divFrameDetail" + random).html(sTmp);
                me.visual.find(".detailedUnits").width(w);
                for (i = 0; i < bluids.length; i++) {
                    sTmp += "<div id='divFrameDetail" + random + "_" + i + "'></div>";
                    param = { "bluid": bluids[i] };
                    me.vcVisual.addVisualBaseByName('divFrameDetail', "VISUAL_UNIT_UNITINFO", random + "_" + i,  window.getCurrentTimestamp(), h, w, "", JSON.stringify(param), me.deviceType);
                }

                break;
            default:
        }
        return true;
    } catch (ex) {
       me.writeError('initClickHandler', ex); return false }
};

ProjectSummary.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            // me.visual.find('').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};

